
export function Alpha1_0(sprite: Laya.Sprite, repeat : number, a : number, duration1: number, duration2: number) {
    Laya.Tween.clearTween(sprite);
    Laya.Tween.to(sprite, { alpha: a }, duration1, null, Laya.Handler.create(null, () => {
        Laya.Tween.to(sprite, { alpha: 0 }, duration2, null, Laya.Handler.create(null, () => {
            if(repeat > 0)
                Alpha1_0(sprite, repeat - 1, a, duration1, duration2);
        }));
    }));
}

export function Alpha0_2(sprite: Laya.Sprite, a: number, dur: number) {
    Laya.Tween.clearTween(sprite);
    Laya.Tween.to(sprite, { alpha: a }, dur, null, null);
}

export function Scale(sprite: Laya.Sprite, repeat : number, a : number, duration1: number, duration2: number, call?: () => void) {
    Laya.Tween.clearTween(sprite);
    Laya.Tween.to(sprite, { scaleX: a, scaleY: a }, duration1, null, Laya.Handler.create(null, () => {
        Laya.Tween.to(sprite, { scaleX: 1, scaleY: 1 }, duration2, null, Laya.Handler.create(null, () => {
            if(repeat > 0)
                Scale(sprite, repeat - 1, a, duration1, duration2, call);
            else
                call?.();
        }));
    }));
}

export function Size(sprite: Laya.Sprite, w: number, h: number, repeat : number, a : number, duration1: number, duration2: number, call?: () => void) {
    Laya.Tween.clearTween(sprite);
    Laya.Tween.to(sprite, { width: w * a, height: h * a }, duration1, null, Laya.Handler.create(null, () => {
        Laya.Tween.to(sprite, { width: w, height: h }, duration2, null, Laya.Handler.create(null, () => {
            if(repeat > 0)
                Size(sprite, w, h, repeat - 1, a, duration1, duration2, call);
            else
                call?.();
        }));
    }));
}


export function Box_Scale(box: Laya.Box, repeat : number, a : number, duration1: number, duration2: number, call?: () => void) {
    Laya.Tween.clearTween(box);
    Laya.Tween.to(box, { scaleX: a, scaleY: a }, duration1, null, Laya.Handler.create(null, () => {
        Laya.Tween.to(box, { scaleX: 1, scaleY: 1 }, duration2, null, Laya.Handler.create(null, () => {
            if(repeat > 0)
                Scale(box, repeat - 1, a, duration1, duration2, call);
            else
                call?.();
        }));
    }));
}

export function Rotate(sprite: Laya.Sprite, repeat : number, a : number, dur: number, call: () => void) {
    Laya.Tween.clearTween(sprite);
    let rot = sprite.rotation;
    Laya.Tween.to(sprite, { rotation: rot + a }, dur * 0.5, null, Laya.Handler.create(null, () => {
        Laya.Tween.to(sprite, { rotation: rot - a }, dur, null, Laya.Handler.create(null, () => {
            Laya.Tween.to(sprite, { rotation: rot }, dur * 0.5, null, Laya.Handler.create(null, () => {
                if(repeat > 0)
                    Rotate(sprite, repeat - 1, a, dur, call);
                else
                    call();
            }));
        }));
    }));
}

export function ScaleLoop(sprite: Laya.Sprite, to: number, dur: number, call: () => void) {
    Laya.Tween.clearTween(sprite);
    let scale = sprite.scaleX;
    Laya.Tween.to(sprite, { scaleX: scale + to, scaleY: scale + to }, dur * 0.25, null, Laya.Handler.create(null, () => {
        Laya.Tween.to(sprite, { scaleX: scale - to, scaleY: scale - to }, dur * 0.5, null, Laya.Handler.create(null, () => {
                Laya.Tween.to(sprite, { scaleX: 1, scaleY: 1}, dur * 0.25, null, Laya.Handler.create(null, () => {
                    ScaleLoop(sprite, to, dur, null);
            }));
        }));
    }));
}

export function ShowScore(parent: Laya.Sprite, template: Laya.Label, score : number, x: number, y: number) {
    let text = new Laya.Label();
    text.anchorX = 0.5;
    text.anchorY = 0.5;
    text.text = score.toString();
    text.fontSize = template.fontSize;
    text.color = template.color;
    text.strokeColor = template.strokeColor;
    text.stroke = template.stroke;
    text.alpha = 1;
    text.x = x;
    text.y = y;
    parent.addChild(text);
    let a = 1.2;
    let duration1 = 500;
    Laya.Tween.to(text, { scaleX: a, scaleY: a }, duration1, null);
    Laya.Tween.to(text, { alpha: 0 }, duration1, null, Laya.Handler.create(null, () => {
        text.removeSelf();
    }));
    
}
